export default __webpack_public_path__ + "static/media/SDG11.f2901ded.png";